import get from 'lodash/get';
import { gettingLanguageNames, getItemOrDefaultToValue } from '../../details';
import { columns as assignedAssetsColumns } from 'containers/Pages/Assets/Assets/columns';

import { transform as assignedAssetsTransform } from 'utils/DataTransform/Asset/AssetList';
import { getDisplayRoles, getRoleId } from '../../helper/roles';
import { ROLES } from '../../constants';

export const transformUserDetails = ({ data, languageList }) => {
  const isRoleResponder = roles => {
    return roles.includes(ROLES.RESPONDER.id);
  };
  return {
    generalInfo: {
      employeeId: {
        type: 'text',
        label: 'Employee ID',
        value: getItemOrDefaultToValue(data.general, 'employeeId', '-'),
      },
      role: {
        type: 'textTranslated',
        value: getDisplayRoles(data.general),
        idValue: getRoleId(data.general),
      },
      firstName: {
        type: 'text',
        value: getItemOrDefaultToValue(data.general, 'firstName', '-'),
      },
      lastName: {
        type: 'text',
        value: getItemOrDefaultToValue(data.general, 'lastName', '-'),
      },
      phone: {
        type: 'text',
        value:
          data.general.phoneNumber !== null
            ? `${getItemOrDefaultToValue(
                data.general.phoneNumber,
                'prefix',
              )} ${getItemOrDefaultToValue(
                data.general.phoneNumber,
                'number',
                '-',
              )}`
            : '-',
      },
      email: {
        type: 'text',
        value: getItemOrDefaultToValue(data.general, 'email', '-'),
      },
    },
    ...(isRoleResponder(data.general.roles)
      ? {
          detailedInfo: {
            services: {
              type: 'icons',
              value: getItemOrDefaultToValue(data.details, 'services', []),
            },
            qualifications: {
              type: 'array',
              value: getItemOrDefaultToValue(
                data.details,
                'qualifications',
                [],
              ),
            },
            // experiences: {
            //   type: 'text',
            //   value: getItemOrDefaultToValue(data.details, 'experiences', [
            //     '-',
            //   ]).join('; '),
            // },
            // identifications: {
            //   type: 'array',
            //   value: getItemOrDefaultToValue(data.details, 'identityDocs', []),
            // },
            languages: {
              type: 'text',
              value:
                data.details.languages != null
                  ? gettingLanguageNames(
                      get(data.details, 'languages', []),
                      languageList,
                    )
                  : '-',
            },
            assignedAssets: {
              type: 'list-data',
              value: {
                data:
                  data.operational.assignedAssets !== null
                    ? assignedAssetsTransform(
                        getItemOrDefaultToValue(
                          data.operational,
                          'assignedAssets',
                          [],
                        ),
                      )
                    : [],
                columns: assignedAssetsColumns,
              },
            },
          },
        }
      : {}),
    others: {
      id: { value: data.general.id },
      phone: {
        value:
          data.general.phoneNumber !== null
            ? getItemOrDefaultToValue(data.general.phoneNumber, 'number', '-')
            : '-',
      },
      image: {
        value: getItemOrDefaultToValue(data.general, 'photoUrl'),
      },
      active: { value: getItemOrDefaultToValue(data.details, 'active', false) },
      // status: {
      //   value: getItemOrDefaultToValue(data.operational, 'status', 'INACTIVE'),
      // },
      languages: {
        value: getItemOrDefaultToValue(data.details, 'languages', []),
      },
      country: {
        value:
          data.general.phoneNumber !== null
            ? getItemOrDefaultToValue(data.general.phoneNumber, 'country', '-')
            : '-',
      },
      // experiences: {
      //   value: getItemOrDefaultToValue(data.details, 'experiences', []),
      // },
    },
  };
};
